// extracted by mini-css-extract-plugin
export var columnList = "_c7-0";